import { createSlice } from "@reduxjs/toolkit";
import {getEngineeringIdpStatusRepo, postEngineeringIdpRepo, postImsPushRepo, getEngineeringIdpNonPanCollegesRepo} from '../../repositories/engineering'

const engineeringFormlSlice = createSlice({
  name: "engineeringFormreducer",
  initialState: {
    engineeringIdpLoading: null,
    engineeringIdpSuccess: null,
    engineeringIdpError: null,

    engineeringIdpNonpanCollegesLoading: null,
    engineeringIdpNonpanCollegesSuccess: null,
    engineeringIdpNonpanCollegesError: null,

    postEngineeringIdpSuccess: null,
    postEngineeringIdpError: null,  
    
    postImsPushSuccess: null,
    postImsPushError: null,  
  },

  reducers: {
    //IDP status
    getEngineeringIdpLoading(state, action) {
      return {
        ...state,
        engineeringIdpLoading: true,
      };
    },
    getEngineeringIdpSuccess(state, action) {
      return {
        ...state,
        engineeringIdpLoading: false,
        engineeringIdpSuccess: action.payload,
      };
    },
    getEngineeringIdpFailure(state, action) {
      return {
        ...state,
        engineeringIdpLoading: false,
        engineeringIdpError: action.payload,
      };
    },

    //engineeringIdpNonpanColleges
    getEngineeringIdpNonpanCollegesLoading(state, action) {
      return {
        ...state,
        engineeringIdpNonpanCollegesLoading: true,
      };
    },
    getEngineeringIdpNonpanCollegesSuccess(state, action) {
      return {
        ...state,
        engineeringIdpNonpanCollegesLoading: false,
        engineeringIdpNonpanCollegesSuccess: action.payload,
      };
    },
    getEngineeringIdpNonpanCollegesFailure(state, action) {
      return {
        ...state,
        engineeringIdpNonpanCollegesLoading: false,
        engineeringIdpNonpanCollegesError: action.payload,
      };
    },

    //postEngineeringIdp
    postEngineeringIdpSuccess(state, action) {
      return {
        ...state,
        postEngineeringIdpSuccess: action.payload,
      };
    },
    postEngineeringIdpFailure(state, action) {
      return {
        ...state,
        postEngineeringIdpError: action.payload,
      };
    },

    //postImsPush
    postImsPushSuccess(state, action) {
      return {
        ...state,
        postImsPushSuccess: action.payload,
      };
    },
    postImsPushFailure(state, action) {
      return {
        ...state,
        postImsPushError: action.payload,
      };
    },
  },
});

export const {
  getEngineeringIdpLoading,
  getEngineeringIdpSuccess,
  getEngineeringIdpFailure,
  getEngineeringIdpNonpanCollegesLoading,
  getEngineeringIdpNonpanCollegesSuccess,
  getEngineeringIdpNonpanCollegesFailure,

  postEngineeringIdpSuccess,
  postEngineeringIdpFailure,
  postImsPushSuccess,
  postImsPushFailure,
} = engineeringFormlSlice.actions;

//getMedicalFormStatus
export const getEngineeringFormData = (params) => {
  return async (dispatch) => {
    await getEngineeringIdpStatusRepo(params)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getEngineeringIdpSuccess(response?.data));
        } else {
          dispatch(getEngineeringIdpFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getEngineeringIdpFailure(error.message));
        }
      });
  };
};

//getEngineeringIdpNonpanColleges
export const getEngineeringNonpanColleges = (params) => {
  return async (dispatch) => {
    await getEngineeringIdpNonPanCollegesRepo(params)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getEngineeringIdpNonpanCollegesSuccess(response?.data));
        } else {
          dispatch(getEngineeringIdpNonpanCollegesFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getEngineeringIdpNonpanCollegesFailure(error.message));
        }
      });
  };
};

export const postEngineeringIdp = (data) => {
  return async (dispatch) => {
    await postEngineeringIdpRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postEngineeringIdpSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postEngineeringIdpFailure(error.message));
        }
      });
  };
};

export const postImsPush = (data) => {
  return async (dispatch) => {
    await postImsPushRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postImsPushSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postImsPushFailure(error.message));
        }
      });
  };
};

export default engineeringFormlSlice.reducer;
